import Layout from '@/layout'
export default {
  path: '/yunyingAdmin',
  component: Layout,
  redirect: '/yunyingAdmin/wenzhangList',
  name: 'yunyingAdmin',
  meta: {
    title: '运营管理',
    icon: 'yunying',
  },
  hidden: false,
  children: [
    {
      path: 'scaleTypeAdmin',
      component: () => import('@/views/yewuAdmin/scaleTypeAdmin/index.vue'),
      name: 'scaleTypeAdmin',
      meta: {
        title: '量表类型',
      },
      hidden: false
    },
    {
      path: 'scaleAdmin',
      component: () => import('@/views/yewuAdmin/scaleAdmin/index'),
      name: 'scaleAdmin',
      meta: {
        title: '量表管理',
        showfater: true,
      },
      hidden: false,
      children: [{
        path: 'scaleAdminD/:scaleCode',
        name: 'scaleAdminD',
        component: () => import('@/views/yewuAdmin/scaleAdmin/scaleAdminD'),
        meta: {
          title: '量表详情',
          showfater: false,
          activeMenu: '/yewuAdmin/scaleAdmin',
        },
        hidden: true,
      }]
    },
    {
      path: 'allSufferer',
      component: () => import('@/views/yewuAdmin/allSufferer/index.vue'),
      name: 'allSufferer',
      meta: {
        title: '全部患者',
        showfater: true
      },
      hidden: false,
      children: [
        {
          path: 'newPatient/:id',
          name: 'newPatient',
          component: () => import('@/views/yewuAdmin/allSufferer/components/SuffererDetail.vue'),
          meta: {
            title: '患者详情',
            showfater: false,
            activeMenu: '/allSufferer/SuffererDetail',
          },
          hidden: true
        },{
          path: 'yiliaoEnter',
          name: 'yiliaoEnter',
          component: () => import('@/views/yewuAdmin/yiliaoEnter/index.vue'),
          meta: {
            title: '医疗录入',
            showfater: false,
            activeMenu: '/yewuAdmin/allSufferer',
          },
          hidden: true
        }, {
          path: 'yiliaoList',
          component: () => import('@/views/yewuAdmin/yiliaoList'),
          name: 'yiliaoList',
          meta: {
            title: '医疗记录',
            showfater: false,
            activeMenu: '/yewuAdmin/allSufferer',
          },
          hidden: true
        }, {
          path: 'getDrugTime',
          component: () => import('@/views/yewuAdmin/getDrugTime'),
          name: 'getDrugTime',
          meta: {
            title: '用药时间表',
            showfater1: true,
            // activeMenu: '/yewuAdmin/allSufferer',
          },
          hidden: true,
          children: [
            {
              path: 'addYongYao',
              component: () => import('@/views/yewuAdmin/getDrugTime/addYongYao'),
              name: 'addYongYao',
              meta: {
                title: '添加用药时间表',
                showfater: false,
                // activeMenu: '/yewuAdmin/allSufferer',
              },
              hidden: true,
            }
          ]
        }, {
          path: 'fuzhenInfo',
          component: () => import('@/views/yewuAdmin/fuzhenInfo'),
          name: 'fuzhenInfo',
          meta: {
            title: '复诊信息',
            showfater: false,
            activeMenu: '/yewuAdmin/allSufferer',
          },
          hidden: true,
        }, {
          path: 'healthFood',
          component: () => import('@/views/yewuAdmin/healthFood'),
          name: 'healthFood',
          meta: {
            title: '健康膳食',
            showfater: false,
            activeMenu: '/yewuAdmin/allSufferer',
          },
          hidden: true,
        }
      ]
    },
    {
      path: 'mySuffererAdmin',
      component: () => import('@/views/yewuAdmin/mySuffererAdmin/index.vue'),
      name: 'mySuffererAdmin',
      meta: {
        title: '我的患者',
        showfater: true
      },
      hidden: false,
      children: [{
        path: 'newPatient/:id',
        name: 'newPatient',
        component: () => import('@/views/yewuAdmin/allSufferer/components/SuffererDetail.vue'),
        meta: {
          title: '患者详情',
          showfater: false,
          activeMenu: '/allSufferer/SuffererDetail',
        },
        hidden: true
      },{
        path: 'yiliaoEnter',
        name: 'yiliaoEnter',
        component: () => import('@/views/yewuAdmin/yiliaoEnter/index.vue'),
        meta: {
          title: '医疗录入',
          showfater: false,
          activeMenu: '/yewuAdmin/mySuffererAdmin',
        },
        hidden: true
      }, {
        path: 'yiliaoList',
        component: () => import('@/views/yewuAdmin/yiliaoList'),
        name: 'yiliaoList',
        meta: {
          title: '医疗记录',
          showfater: false,
          activeMenu: '/yewuAdmin/mySuffererAdmin',
        },
        hidden: true
      }, {
        path: 'getDrugTime',
        component: () => import('@/views/yewuAdmin/getDrugTime'),
        name: 'getDrugTime',
        meta: {
          title: '用药时间表',
          showfater1: true,
          activeMenu: '/yewuAdmin/mySuffererAdmin',
        },
        hidden: true,
        children: [{
          path: 'addYongYao',
          component: () => import('@/views/yewuAdmin/getDrugTime/addYongYao'),
          name: 'addYongYao',
          meta: {
            title: '添加用药时间表',
            showfater: false,
            activeMenu: '/yewuAdmin/mySuffererAdmin',
          },
          hidden: true,
        }]
      }, {
        path: 'fuzhenInfo',
        component: () => import('@/views/yewuAdmin/fuzhenInfo'),
        name: 'fuzhenInfo',
        meta: {
          title: '复诊信息',
          showfater: false,
          activeMenu: '/yewuAdmin/mySuffererAdmin',
        },
        hidden: true,
      }, {
        path: 'healthFood',
        component: () => import('@/views/yewuAdmin/healthFood'),
        name: 'healthFood',
        meta: {
          title: '健康膳食',
          showfater: false,
          activeMenu: '/yewuAdmin/mySuffererAdmin',
        },
        hidden: true,
      }]
    },
    {
      path: 'allAnyAccess',
      component: () => import('@/views/yewuAdmin/allAnyAccess/index.vue'),
      name: 'allAnyAccess',
      meta: {
        title: '全部评估',
        showfater: true,
      },
      hidden: false,
      children: [{
        path: 'pingGuD',
        component: () => import('@/views/yewuAdmin/pingGuD/pingguD.vue'),
        // component: () => import('@/views/yewuAdmin/pingGuD/index.vue'),
        name: 'pingGuD',
        meta: {
          title: '评估详情',
          showfater: false,
          activeMenu: '/yewuAdmin/allAnyAccess',
        },
        hidden: true,
      }]
    },
    {
      path: 'myAnyAccessAdmin',
      component: () => import('@/views/yewuAdmin/myAnyAccessAdmin/index.vue'),
      name: 'myAnyAccessAdmin',
      meta: {
        title: '我的评估',
        showfater: true,
      },
      hidden: false,
      children: [{
        path: 'pingGuD',
        component: () => import('@/views/yewuAdmin/pingGuD/pingguD.vue'),
        // component: () => import('@/views/yewuAdmin/pingGuD/index.vue'),
        name: 'pingGuD',
        meta: {
          title: '评估详情',
          showfater: false,
          activeMenu: '/yewuAdmin/myAnyAccessAdmin',
        },
        hidden: true,
      }]
    },
    {
      path: 'diseaseManage',
      component: () => import('@/views/baseInfoService/diseaseManage/index.vue'),
      name: 'diseaseManage',
      meta: {
        title: '病种管理',
      },
      hidden: false
    },
    {
      path: 'indexManage',
      name: 'indexManage',
      component: () => import('@/views/healthWarning/indexManage/index.vue'),
      meta: {
        title: '预警指标管理',
        showfater: true,
      },
      hidden: false,
      children: []
    },
    {
      path: 'followUpRules',
      name: 'followUpRules',
      component: () => import('@/views/yunyingAdmin/followUpRules/index.vue'),
      meta: {
        title: '随访规则设置',
        showfater: true,
      },
      hidden: false,
      children: []
    },
    {
      path: 'telFollowUpTpl',
      name: 'telFollowUpTpl',
      component: () => import('@/views/followUpTpl/tel/index.vue'),
      meta: {
        title: '电话随访模板',
        showfater: true,
      },
      hidden: false,
      children: []
    },
    // {
    //   path: 'visitFollowUpTpl',
    //   name: 'visitFollowUpTpl',
    //   component: () => import('@/views/followUpTpl/visit/index.vue'),
    //   meta: {
    //     title: '上门随访模板',
    //     showfater: true,
    //   },
    //   hidden: false,
    //   children: []
    // },
    {
      path: 'ziPingLiangBiao',
      component: () => import('@/views/yewuAdmin/ziPingLiangBiao'),
      name: 'ziPingLiangBiao',
      meta: {
        title: '问卷模板',
        showfater: true
      },
      hidden: false,
      children: [{
        path: 'addZipingList',
        component: () => import('@/views/yewuAdmin/ziPingLiangBiao/addZipingList'),
        name: 'addZipingList',
        meta: {
          title: '添加模板',
          showfater: false
        },
        hidden: true,
      }]
    },
    {
      path: 'msgFollowUpTpl',
      name: 'msgFollowUpTpl',
      component: () => import('@/views/followUpTpl/msg/index.vue'),
      meta: {
        title: '短信模板',
        showfater: true,
      },
      hidden: false,
      children: []
    },
    {
      path: 'knowledgeBaseManage',
      component: () => import('@/views/yewuAdmin/knowledgeBaseManage'),
      name: 'knowledgeBaseManage',
      meta: {
        title: '知识库管理'
      },
      hidden: false,
    },
    // {
    //   path: 'yaopingzhushou',
    //   component: () => import('@/components/NestPage/index.vue'),
    //   name: 'yaopingzhushou',
    //   meta: {
    //     title: '药品助手',
    //     link: "https://drugs.dxy.cn/pc/search?keyword=%E6%90%9C%E7%B4%A2%E7%96%BE%E7%97%85%E3%80%81%E6%8C%87%E5%8D%97%E3%80%81%E8%8D%AF%E5%93%81",
    //     showfater: true
    //   },
    //   hidden: false,
    // },

    {
      path: 'wenzhangList',
      component: () => import('@/views/yunyingAdmin/wenzhangList'),
      name: 'wenzhangList',
      meta: {
        title: '文章管理',
        showfater: true
      },
      hidden: false,
      children: [{
        path: 'dispatchArticle',
        component: () => import('@/views/yunyingAdmin/wenzhangList/dispatchArticle'),
        meta: {
          title: '主推文章设置',
          showfater: false
        },
        hidden: true,
      }, {
        path: 'hotWord',
        component: () => import('@/views/yunyingAdmin/wenzhangList/hotWord'),
        meta: {
          title: '搜热词设置',
          showfater: false
        },
        hidden: true,
      }, {
        path: 'addActical',
        component: () => import('@/views/yunyingAdmin/wenzhangList/addActical'),
        meta: {
          title: '发布文章',
          showfater: false
        },
        hidden: true,
      }]
    },
    // {
    //   path: 'ziPingLiangBiao',
    //   component: () => import('@/views/yunyingAdmin/ziPingLiangBiao'),
    //   name: 'ziPingLiangBiao',
    //   meta: {
    //     title: '自评量表管理',
    //     showfater: true
    //   },
    //   hidden: false,
    //   children: [{
    //     path: 'addZipingList',
    //     component: () => import('@/views/yunyingAdmin/ziPingLiangBiao/addZipingList'),
    //     name: 'addZipingList',
    //     meta: {
    //       title: '添加自评量表',
    //       showfater: false
    //     },
    //     hidden: true,
    //   }]
    // },
    //  {
    //   path: 'pushAdmin',
    //   component: () => import('@/views/yunyingAdmin/pushAdmin'),
    //   name: 'pushAdmin',
    //   meta: {
    //     title: '推送管理',
    //   },
    //   hidden: false
    // },
  ]
}